import "./login.css";
import { useEffect } from "react";
import UserService from "../../utils/UserService";
import kcUser from "../../utils/keycloak.js";
import Keycloak from "keycloak-js";
import { useAuth } from "../../utils/Auth/AuthContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user) {
      navigate("/home-tax");
      return;
    }

    if (!loading && !user) {
      gotoLogin();
    }
  }, [loading, user, navigate]);
  if (loading) return <div>Carregando...</div>;
  function gotoLogin() {
    let kcConfig: any = kcUser;
    let _Kc: any = new Keycloak(kcConfig);
    UserService.doLogin();
  }

  return <div className="mainLogin"></div>;
};

export default Login;
